<template>
  <ImgComponentContent
    :src="src"
    :fallback="fallback"
    :avatar="avatar"
    :defaultAvatarStyle="defaultAvatarStyle"
    :key="`${src}${fallback}${avatar}${defaultAvatarStyle}`"
  />
</template>

<script>
import { defineComponent } from 'vue'
import ImgComponentContent from './ImgComponentContent.vue'

export default defineComponent({
  name: 'ImgComponent',
  components: { ImgComponentContent },
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, default: '' },
    avatar: { type: [Boolean, String], default: false },
    defaultAvatarStyle: { type: String, default: '' },
  },
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {},
})
</script>
